import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollQueryEmployeeFieldsResponse,
  PayrollQueryEmployeeFieldsVariables,
} from '../types';

export const queryEmployeeFieldsQuery = gql`
  query PayrollQueryEmployeeFields(
    $clauses: [PayrollFieldClauseInput!]
    $pageSize: Int
    $pageToken: String
  ) {
    payrollQueryEmployeeFields(clauses: $clauses, pageSize: $pageSize, pageToken: $pageToken) {
      userIds
      total
      nextPageToken
    }
  }
`;

export const queryEmployeeFields = (queryVariables: PayrollQueryEmployeeFieldsVariables) =>
  graphQLApi<PayrollQueryEmployeeFieldsResponse, PayrollQueryEmployeeFieldsVariables>({
    query: queryEmployeeFieldsQuery,
    queryVariables,
  });
